var React = require('react');

function TiktokDarkInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"rx":"15%","height":"512","width":"512","fill":"#fff","key":0}),React.createElement("defs",{"key":1},React.createElement("path",{"id":"t","d":"M219 200a117 117 0 1 0 101 115v-128a150 150 0 0 0 88 28v-63a88 88 0 0 1-88-88h-64v252a54 54 0 1 1-37-51z","style":{"mixBlendMode":"multiply"}})),React.createElement("use",{"href":"#t","fill":"#f05","x":"18","y":"15","key":2}),React.createElement("use",{"href":"#t","fill":"#0ee","key":3})]);
}

TiktokDarkInline.defaultProps = {"aria-label":"TikTok","role":"img","viewBox":"0 0 512 512"};

module.exports = TiktokDarkInline;

TiktokDarkInline.default = TiktokDarkInline;
